module.exports = __webpack_public_path__ + "img/location.382a8a6d.svg";